import React = require('react')
import { Action, AsyncState, mk_widget, Pair, Widget } from 'widgets-for-react'
import { getTranslatedCareersSlugTitle, PublicSiteState } from '../../../../../public_site.main.mod'
import { CustomRouteParams } from '../../../../cms/router/type.gen'
import { Pagination } from '../../../templates/pagination.mod'
import { CustomPagesState, PublicSiteCustomRoutes, TagTitle, TagValues, overview_tag_to_url_tag, overview_tag_to_taxonomy_title, page_kind_to_tag_list } from '../../types.mod'
import { OverviewStyle } from './overview_page_layout'
import { Map } from 'immutable'
import { ParsedOverviewDetailItem } from './components/overviewItemsBlock/overview_items_block'
import { mapPageKindToSlug } from '../../custom_pages.mod'
import { loadTags, PaginatedItemStone } from '../../../../drupal/api/api.mod'
import { headerSearchBarFormDatalayer } from '../../../../datalayer'
import { getLangFromUrl } from '../../../utils/history.mod'
import { getDrupalLanguage } from '../../../application.mod'


export type PageKind = 'resource-overview' | 'search-overview' | 'vacancy-overview' | 'news-overview' | 'team-overview' | 'testimonial-overview'
export const pageKinds: PageKind[] = ['resource-overview', 'search-overview', 'vacancy-overview', 'news-overview', 'team-overview', 'testimonial-overview']

export const encode_tag = (tag: string) => {
  return tag.replace(/&/g, '!<').replace(/,/g, '>!')
}
export const decode_tag = (tag: string) => {
  return tag.replace(/!</g, '&').replace(/>!/g, ',')
}

const getWindowHistory = (
  page_kind: PageKind,
  tags: Map<TagTitle, TagValues>,
  // industryTag: string[],
  // typeTag: string[],
  searchQuery: string,
  page_index: number
): string => {
  let params: string[] = []

  tags.forEach((v, k) => {
    v.forEach((i, index) => {
      let k1 = k
      if (i == "") return
      k1 = overview_tag_to_url_tag(k1)
      params.push(`${k1}[${index}]=${i}`)
    })
  })

  if (searchQuery) params.push(`searchQuery=${searchQuery}`)
  return `/${getLangFromUrl()}/${getTranslatedCareersSlugTitle().slug[getLangFromUrl()]}/${mapPageKindToSlug(page_kind)}/${page_index}${params.length > 0 ? `/?${params.join("&")}` : ''}`
}
const setWindowHistory = (page_kind: PageKind, tags: Map<TagTitle, TagValues>, searchQuery: string, page_index: number) => {
  //window.history.pushState(undefined, undefined, getWindowHistory(p, page_kind, tags, searchQuery, page_index))
  window.history.pushState({}, "", getWindowHistory(page_kind, tags, searchQuery, page_index))
  var popStateEvent = new PopStateEvent('popstate', { state: {} });
  dispatchEvent(popStateEvent)
}

export let prev_tags = undefined
export let reset_prev_tags = () => { prev_tags = undefined }

export const renderOverviewPage = (loadOverviewItems: (page_kind: PageKind, tags: Map<TagTitle, TagValues>, searchQuery: string, page_index: number, page_size?: number, lang?: string) => AsyncState<PaginatedItemStone<ParsedOverviewDetailItem>>) => (
  overviewState: CustomPagesState['overview'],
  appState: Pair<CustomRouteParams<PublicSiteState, PublicSiteCustomRoutes>, CustomPagesState['overview']>,
  setState: (_: Action<CustomPagesState['overview']>) => void,
  style: OverviewStyle,
  page_kind: PageKind
) => {
  const filterTagChanged = (tags: Map<TagTitle, TagValues>, searchQuery: string): void => {
    if (searchQuery != undefined) {
      appState.snd.selected_options.searchQuery = searchQuery
    }

    setWindowHistory(
      appState.snd.pageKind,
      tags.mapEntries((([k, v]) => [k, v.map(f => encode_tag(f))])).toMap() as any,

      // industryTag.map(f => encode_tag(f)),
      // typeTag.map(f => encode_tag(f)),
      appState.snd.selected_options.searchQuery,
      0
    )
    setState(oldState => {
      let oldState1 =
      {
        ...oldState,
        selected_options: {
          ...oldState.selected_options,
          tags,
          searchQuery: searchQuery || oldState.selected_options.searchQuery
          // industryTag,
          // typeTag
        },
        overview_items: loadOverviewItems(
          oldState.pageKind,
          tags,
          // industryTag,
          // typeTag,
          appState.snd.selected_options.searchQuery,
          0,
          10,
          getLangFromUrl()
        )
      }

      page_kind_to_tag_list("vacancy-overview").forEach(tag => {
        oldState1.tags = oldState1.tags.set(tag,
          loadTags(
            oldState1.pageKind,
            getLangFromUrl(),
            overview_tag_to_taxonomy_title(tag),
            tags
          ))
      })

      return oldState1
    })
  }
  const searchQueryChanged = (searchQuery: string): void => {

    // window.dataLayer.push({
    //   event: `event.${sitename}`,
    //   category: page_kind,
    //   action: `filter-search`,
    //   label: searchQuery
    // })

    setState(oldState => ({
      ...oldState,
      selected_options: {
        ...oldState.selected_options,
        searchQuery
      }
    }))
  }
  const searchSubmitted = (): void => {

    setWindowHistory(
      appState.snd.pageKind,
      appState.snd.selected_options.tags.mapEntries((([k, v]) => [k, v.map(f => encode_tag(f))])).toMap() as any,
      // appState.snd.selected_options.industryTag,
      // appState.snd.selected_options.typeTag,
      appState.snd.selected_options.searchQuery,
      0
    )
    setState(oldState => ({
      ...oldState,
      overview_items: loadOverviewItems(
        oldState.pageKind,
        appState.snd.selected_options.tags,
        // appState.snd.selected_options.industryTag,
        // appState.snd.selected_options.typeTag,
        appState.snd.selected_options.searchQuery,
        0,
        10,
        getLangFromUrl()
      )
    }))
  }
  if (overviewState.tags.find(t => t.kind != "loaded") == undefined) {
    prev_tags = overviewState.tags
  }
  if (overviewState.pageKind == 'vacancy-overview' && overviewState.selected_options.searchQuery.length > 0 && overviewState.overview_items.kind == 'loaded') {
    headerSearchBarFormDatalayer(overviewState.overview_items.value.items.count() > 0 ? 'result' : 'no_result', overviewState.selected_options.searchQuery)
  }
  let draw_filters = overviewState.pageKind == "resource-overview" && overviewState.tags.find(t => t.kind != "loaded") == undefined ?
    style.renderFilterBlock(page_kind, {
      // industryTags: overviewState.industryTags.value,
      // typeTags: overviewState.typeTags.value,
      tags: overviewState.tags.mapEntries(([k, v]) => [k, v.kind == "loaded" ? v.value : []]).toMap() as Map<TagTitle, TagValues>,
      options: overviewState.selected_options,
      filterTagChanged,
      searchQueryChanged,
      searchSubmitted
    }) : overviewState.pageKind == "vacancy-overview" ?
      style.renderFilterBlock(page_kind, {
        tags: (
          overviewState.tags.find(t => t.kind != "loaded") != undefined
            ? prev_tags == undefined
              ? overviewState.tags
              : prev_tags
            : overviewState.tags
        ).mapEntries(([k, v]) => [k, v.kind == "loaded" ? v.value : []]).toMap() as Map<TagTitle, TagValues>,
        options: overviewState.selected_options,
        filterTagChanged,
        searchQueryChanged,
        searchSubmitted
      }) : overviewState.pageKind == "search-overview" ?
        style.renderFilterBlock(page_kind, {
          // industryTags: [],
          // typeTags: [],
          tags: Map(),
          options: overviewState.selected_options,
          filterTagChanged,
          searchQueryChanged,
          searchSubmitted
        }) : overviewState.pageKind == "news-overview" ?
          style.renderFilterBlock(page_kind, {
            tags: overviewState.tags.mapEntries(([k, v]) => [k, v.kind == "loaded" ? v.value : []]).toMap() as Map<TagTitle, TagValues>,
            options: overviewState.selected_options,
            filterTagChanged,
            searchQueryChanged,
            searchSubmitted
          }) : overviewState.pageKind == "team-overview" ?
            style.renderFilterBlock(page_kind, {
              tags: overviewState.tags.mapEntries(([k, v]) => [k, v.kind == "loaded" ? v.value : []]).toMap() as Map<TagTitle, TagValues>,
              options: overviewState.selected_options,
              filterTagChanged,
              searchQueryChanged,
              searchSubmitted
            })
            : overviewState.pageKind == "testimonial-overview" ?
              style.renderFilterBlock(page_kind, {
                tags: overviewState.tags.mapEntries(([k, v]) => [k, v.kind == "loaded" ? v.value : []]).toMap() as Map<TagTitle, TagValues>,
                options: overviewState.selected_options,
                filterTagChanged,
                searchQueryChanged,
                searchSubmitted
              })
              : null
  return (
    <>
      <>
        <div className="container container--m grid--gutter"> 
          <section className="search-bar">
            <div className="search-bar__inner grid--gutter">

              {/* <header className="sv__header">
                <h2 className="sv__title title--l">{page_kind == "vacancy-overview" ? "" : page_kind == "news-overview" ? "Stories" : page_kind == 'team-overview' ? 'Ons team' : page_kind == 'testimonial-overview' ? "Testimonials" : "Vacancies"}</h2>


                {page_kind == "vacancy-overview" ? null
                  : <button
                    className="button button--primary button--icon button--icon-left"
                    onClick={() => {
                      document.querySelector(".block__filters").classList.toggle("hidden");
                      setState(s => s)
                    }
                    }
                  >
                    <svg aria-hidden="true" width="20px" height="15px"><use xlinkHref="#icon--filter"></use></svg>
                    <span>Filter {document.querySelector(".block__filters") == undefined ||
                      document.querySelector(".block__filters").classList?.contains("hidden") ? "selecteren" : "verbergen"}</span>
                  </button>}

              </header> */}

                {draw_filters}
            </div>
          </section>
        </div>

        {
          overviewState.overview_items.kind == 'loaded' && (page_kind == "vacancy-overview" || page_kind == "news-overview" || page_kind == "team-overview" || page_kind == "testimonial-overview") ?

            style.renderOverviewBlocks(page_kind, overviewState.selected_options.tags, filterTagChanged, overviewState.overview_items.value.items, overviewState.overview_items.value.pager.totalItems) : null
        }

        {overviewState.overview_items.kind == "loaded" && overviewState.overview_items.value.pager.totalPages > 1 && (
          <Pagination
            //isMobile={window.innerWidth <= 768 ? true : false}
            pager={{
              current_page: overviewState.overview_items.value.pager.currentPage,
              items_per_page: overviewState.overview_items.value.pager.itemsPerPage,
              total_items: overviewState.overview_items.value.pager.totalItems,
              total_pages: overviewState.overview_items.value.pager.totalPages,
            }}
            setPage={(p) => {
              setWindowHistory(
                appState.snd.pageKind,
                appState.snd.selected_options.tags.mapEntries((([k, v]) => [k, v.map(f => encode_tag(f))])).toMap() as Map<TagTitle, TagValues>,
                // industryTag.map(f => encode_tag(f)),
                // typeTag.map(f => encode_tag(f)),
                appState.snd.selected_options.searchQuery,
                p
              )
              setState((s) => {
                const s1 = { ...s }
                s1.selected_options.currentPage = p
                s1.overview_items = loadOverviewItems(
                  s1.pageKind,
                  s1.selected_options.tags,
                  // s1.selected_options.industryTag,
                  // s1.selected_options.typeTag,
                  s1.selected_options.searchQuery,
                  s1.selected_options.currentPage,
                  10,
                  getLangFromUrl()
                )
                return s1
              })
            }}
          />
        )}
      </>


      {
        overviewState.overview_items.kind == 'loading' ? Loader()
          : overviewState.overview_items.kind != 'loaded' ? <div>{overviewState.overview_items.kind}</div>
            : null
      }
    </>
  )

}


export const loaderWidget: Widget<never> = mk_widget({ run: (o) => <Loader /> })

export const Loader = () => {
  return (
    <div className="loader">
      <div className="loader__inner">
        <span className="sr-text">Loading...</span>
      </div>
    </div>
  )
}
